import type { Application } from "../types";

export function dossierStatusChip(app: Application) {
  if (app.status === "subcontractor_linked") {
    return <span className="status-chip status-chip--done">Subcontractor linked</span>;
  }
  if (app.status === "icici_recorded") {
    return <span className="status-chip status-chip--progress">Awaiting subcontractor</span>;
  }
  if (app.status === "on_hold") {
    return <span className="status-chip status-chip--hold">On hold</span>;
  }
  if (app.status === "ready_for_mou") {
    return <span className="status-chip status-chip--progress">Ready for MOU</span>;
  }
  if (app.status === "ready_for_icici") {
    return <span className="status-chip status-chip--progress">Ready for ICICI</span>;
  }
  return <span className="status-chip">HO review</span>;
}
